<template>
  <div id="conent">
    <div class="page_container">
      <div class="msg_nav">
        <h1 class="title">{{ category }}</h1>
        <div>
          <img
            src="../assets/image23.png"
            alt=""
            class="inset_img"
          />
        </div>
      </div>

      <!-- loading 状态 -->
      <div v-if="loading" class="loading-overlay">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>

      <!-- list -->
      <div class="list" v-else>
        <div v-for="article in articles" :key="article.url" class="list_item" @click="handleArticleClick(article.url)">
          <div class="item_img">
            <img :src="changeImgUrl(article.img)" alt="" />
          </div>
          <div class="item_content">
            <h3 class="item_title">{{ article.title }}</h3>
            <p class="item_time">{{ article.createtime }}</p>
            <p class="item_text">{{ formatDescription(article.desc) }}</p>
          </div>
          <div class="line_item"></div>
        </div>
      </div>

      <!-- page -->
      <div class="page_button">
        <div class="page_button_content">
          <div
            class="prev_button"
            @click="changePage(currentPage - 1)"
            :disabled="currentPage === 1"
          >
            上一页
          </div>
          <div class="page_text">
            <b class="current_page">{{ currentPage }}</b> / {{ totalPages }}
          </div>
          <div
            class="next_button"
            @click="changePage(currentPage + 1)"
            :disabled="currentPage === totalPages"
          >
            下一页
          </div>
        </div>
      </div>

      <div style="clear: both"></div>
    </div>
  </div>
</template>

<script>
import { articleApi } from "@/api/article";
import base64 from 'base-64';

export default {
  name: "MessageList",
  data() {
    return {
      category: "协会资讯",
      category_id: 28,
      articles: [],
      currentPage: 1,
      pageSize: 10,
      totalPages: 0,
      loading: false // 添加 loading 状态
    };
  },
  methods: {
    async fetchArticles(pageIndex) {
      this.loading = true; // 开始加载
      try {
        const response = await articleApi.getArticlesByCategory(
          this.category_id,
          pageIndex,
          this.pageSize
        );
        if (response.code === 200) {
          this.articles = response.data.articles;
          this.totalPages = response.data.total_pages;
        }
      } catch (error) {
        console.error("获取文章失败:", error);
      } finally {
        this.loading = false; // 结束加载
      }
    },
    changeImgUrl(url){
      return url.replace("https://static.duud.cn/", "https://wq-1258021341.cos.ap-guangzhou.myqcloud.com/");
    },
    changePage(pageIndex) {
      if (pageIndex < 1 || pageIndex > this.totalPages) return;
      this.currentPage = pageIndex;
      this.fetchArticles(pageIndex);
    },
    formatDescription(desc) {
      const hasLinkOrDecode = /tmlDecode|http[s]?:\/\//.test(desc);
      return hasLinkOrDecode ? "" : desc;
    },
    handleArticleClick(url) {
      const page = "https://duud.cn/app/" + url;
      const base64Url = base64.encode(page);
      let idx = this.$route.query.idx;
      this.$router.push({ name: 'articleDetail', query: { url: base64Url, category: this.category,idx:idx } });
    }
  },
  mounted() {
    let idx = this.$route.query.idx;
    if(idx==2){
      this.category = "协会资讯"
      this.category_id = 28;
    }else if(idx ==3){
      this.category = "办事指南"
      this.category_id = 63;
    }else if(idx ==4){
      this.category = "政策法规"
      this.category_id = 35;
    }
    this.fetchArticles(1);
  },
};
</script>

<style scoped>
@import "../style/common.css";
@import "../style/message-list.css";
@import "../style/loading.css";
</style>